import { Typography } from '@mui/material';
import {
  composeValidators,
  EditableTextValue,
  maxLength,
  pattern,
  required,
} from '@retail/components';
import { useAppTFunction } from '@retail/app/i18n';
import { safeTextRegex } from '@retail/form/validation';
import { MAX_CAMPAIGN_NAME_LENGTH } from '../CreateCampaign';

interface CampaignNameProps {
  name: string;
  onSave?: (name: string) => void;
}

export const CampaignName = ({ name, onSave }: CampaignNameProps) => {
  const t = useAppTFunction();
  const validation = composeValidators(
    required(t('validation.required')),
    maxLength(MAX_CAMPAIGN_NAME_LENGTH, t('validation.maxLength', { max: MAX_CAMPAIGN_NAME_LENGTH })),
    pattern(safeTextRegex, t('validation.safeText'))
  );

  return (
    <EditableTextValue
      editable={!!onSave}
      renderValue={() => (
        <Typography variant="h4" component="h1">
          {name}
        </Typography>
      )}
      onSave={(name) => onSave && onSave(name)}
      defaultValue={name}
      maxLength={MAX_CAMPAIGN_NAME_LENGTH}
      validate={validation}
    />
  );
};
